import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';

interface CheckboxProps {
  label: string;
  meta: {
    touched: boolean;
    invalid: boolean;
    error: boolean;
  };
  input: { value: boolean; onChange: any };
  fullWidth: boolean;
}

const CheckboxField = ({ label, input, fullWidth }: CheckboxProps) => (
  <FormControl fullWidth={fullWidth}>
    <FormControlLabel
      control={
        <Checkbox
          checked={input.value ? true : false}
          onChange={input.onChange}
        />
      }
      label={label}
    />
  </FormControl>
);

export default CheckboxField;
